// @ts-strict-ignore
export const Swiper = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.72038 8.71413C5.43538 8.97158 5.43574 9.41906 5.72115 9.67605L11.8309 15.1775C12.2112 15.52 12.7888 15.52 13.1691 15.1775L19.2156 9.73296C19.5349 9.44553 19.5353 8.94505 19.2165 8.65711C18.9407 8.40798 18.5211 8.40798 18.2453 8.65711L12.8352 13.5444C12.6448 13.7163 12.3552 13.7163 12.1648 13.5444L6.81778 8.71413C6.50614 8.43261 6.03201 8.43261 5.72038 8.71413Z"
				fill="#292424"
			/>
		</svg>
	)
}
